<template>
  <div class="form-container">
    <div class="material-box" v-for="(order, orderIndex) in formList" :key="orderIndex">
      <div class="close" @click.stop="delOrder(orderIndex)">
        <i class="iconfont icon-close"></i>
      </div>
      <div class="cell no-boder">
        <div class="name">包装材质</div>
        <div class="choose" @click="order.isDecide && checkMaterial(orderIndex)" :class="[
          { color: order.packMaterial },
          { active: prfTLookDecide },
          { error: isError && !order.packMaterial },
          {
            material: !order.isDecide,
          },
        ]">
          {{
            order.packMaterial
              ? order.packMaterial === 1
                ? "六面泡沫包装"
                : order.packMaterial === 2
                  ? "蜂窝包装"
                  : order.packMaterial === 3
                    ? "蜂窝包装+FSC"
                    : ""
              : "请选择"
          }}<i v-if="order.isDecide" class="iconfont icon-a-xialakaobei"></i>
        </div>
      </div>
      <div class="cell">
        <div class="name">颜色</div>
        <div class="button" @click.stop="checkColor(orderIndex)">添加颜色</div>
      </div>
      <div class="color-list">
        <div v-for="(color, colorKey) in order.orderList" :key="colorKey" class="color-item">
          <div class="cell">
            <div class="name title">
              {{ color.colorAskName }}（{{ getMarketSum(color) }}件）
            </div>
          </div>
          <div class="cell no-boder">
            <div class="title">市场</div>
            <div class="button" :class="{
              disabled:
                color.allList.length >= 1 &&
                color.asianList.length >= 1 &&
                color.europeList.length >= 1,
            }" @click="handleAddBarrzer(orderIndex, colorKey)">
              添加市场
            </div>
          </div>
          <div v-if="color.allList.length">
            <div class="cell no-boder">
              <div class="title">美加澳市场</div>
              <div class="button" :class="{ disabled: color.allList.length >= 3 }" @click.stop="
                handleAddCountry(
                  'allList',
                  orderIndex,
                  colorKey,
                  color.allList.length >= 3
                )
                ">
                添加国家
              </div>
            </div>
            <div class="country-box" style="margin-bottom: 10px" :key="countryKey"
              v-for="(country, countryKey) in getisDecideList(color, 'allList')">
              <div class="close" @click.stop="
                handleDeleteCountry(
                  orderIndex,
                  colorKey,
                  'allList',
                  country.uuid
                )
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="cell no-border" v-if="!country.countryTypeName || country.codes.length === 0">
                <div class="name"><span>*</span>国家</div>
                <div class="choose" @click="
                  handleAddCt(
                    'allList',
                    orderIndex,
                    colorKey,
                    1,
                    country.uuid
                  )
                  " :class="[
                    { color: country.countryTypeName },
                    {
                      'is-error': isError && !country.countryTypeName,
                    },
                  ]">
                  {{
                    country.countryTypeName
                      ? country.countryTypeName
                      : "请选择"
                  }}<i class="iconfont icon-a-xialakaobei"></i>
                </div>
              </div>
              <div class="country-top" v-else>
                <div class="left">
                  <span class="round"></span>
                  <span class="title">{{ country.countryTypeName }}</span>
                </div>
                <div class="right" @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'allList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'allList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <div class="cell" v-if="country.codes.length === 0">
                <div class="name"><span>*</span>仓库</div>
                <div @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'allList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'allList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <template v-else>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex,
                  colorKey,
                  'allList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </template>
            </div>

            <div class="country-box" v-if="getLength(color, 'allList')">
              <div class="close" @click.stop="
                handleDeleteOldCountry(orderIndex, colorKey, 'allList')
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="country-item" v-for="(country, countryKey) in getDecideList(color, 'allList')"
                :key="countryKey">
                <div class="country-top">
                  <div class="left">
                    <span class="round"></span>
                    <span class="title">{{ country.countryTypeName }}</span>
                  </div>
                  <div class="right" @click="
                    handleNewChooseStash(
                      orderIndex,
                      colorKey,
                      'allList',
                      countryKey
                    )
                    ">
                    <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                      colorKey,
                      'allList',
                      countryKey) > country.codes.length"></i>
                  </div>
                </div>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex,
                  colorKey,
                  'allList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="color.europeList.length">
            <div class="cell no-boder">
              <div class="title">欧洲市场</div>
              <div class="button" :class="{ disabled: color.europeList.length >= 5 }" @click.stop="
                handleAddCountry(
                  'europeList',
                  orderIndex,
                  colorKey,
                  color.europeList.length >= 5
                )
                ">
                添加国家
              </div>
            </div>
            <div class="country-box" style="margin-bottom: 10px" :key="countryKey" v-for="(country, countryKey) in getisDecideList(
              color,
              'europeList'
            )">
              <div class="close" @click.stop="
                handleDeleteCountry(
                  orderIndex,
                  colorKey,
                  'europeList',
                  country.uuid
                )
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="cell no-border" v-if="!country.countryTypeName || country.codes.length === 0">
                <div class="name"><span>*</span>国家</div>
                <div class="choose" @click="
                  handleAddCt(
                    'europeList',
                    orderIndex,
                    colorKey,
                    2,
                    country.uuid
                  )
                  " :class="[
                    { color: country.countryTypeName },
                    {
                      'is-error': isError && !country.countryTypeName,
                    },
                  ]">
                  {{
                    country.countryTypeName
                      ? country.countryTypeName
                      : "请选择"
                  }}<i class="iconfont icon-a-xialakaobei"></i>
                </div>
              </div>
              <div class="country-top" v-else>
                <div class="left">
                  <span class="round"></span>
                  <span class="title">{{ country.countryTypeName }}</span>
                </div>
                <div class="right" @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'europeList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'europeList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <div class="cell" v-if="country.codes.length === 0">
                <div class="name"><span>*</span>仓库</div>
                <div @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'europeList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'europeList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <template v-else>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex,
                  colorKey,
                  'europeList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </template>
            </div>
            <div class="country-box" v-if="getLength(color, 'europeList')">
              <div class="close" @click.stop="
                handleDeleteOldCountry(orderIndex, colorKey, 'europeList')
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="country-item" v-for="(country, countryKey) in getDecideList(
                color,
                'europeList'
              )" :key="countryKey">
                <div class="country-top">
                  <div class="left">
                    <span class="round"></span>
                    <span class="title">{{ country.countryTypeName }}</span>
                  </div>
                  <div class="right">
                    <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                      colorKey,
                      'europeList',
                      countryKey) > country.codes.length"></i>
                  </div>
                </div>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex,
                  colorKey,
                  'europeList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="color.asianList.length">
            <div class="cell no-boder">
              <div class="title">亚洲市场</div>
              <div class="button" :class="{ disabled: color.asianList.length >= 5 }" @click.stop="
                handleAddCountry(
                  'asianList',
                  orderIndex,
                  colorKey,
                  color.asianList.length >= 5
                )
                ">
                添加国家
              </div>
            </div>

            <div class="country-box" style="margin-bottom: 10px" :key="countryKey" v-for="(country, countryKey) in getisDecideList(
              color,
              'asianList'
            )">
              <div class="close" @click.stop="
                handleDeleteCountry(
                  orderIndex,
                  colorKey,
                  'asianList',
                  country.uuid
                )
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="cell no-border" v-if="!country.countryTypeName || country.codes.length === 0">
                <div class="name"><span>*</span>国家</div>
                <div class="choose" @click="
                  handleAddCt(
                    'asianList',
                    orderIndex,
                    colorKey,
                    3,
                    country.uuid
                  )
                  " :class="[
                    { color: country.countryTypeName },
                    {
                      'is-error': isError && !country.countryTypeName,
                    },
                  ]">
                  {{
                    country.countryTypeName
                      ? country.countryTypeName
                      : "请选择"
                  }}<i class="iconfont icon-a-xialakaobei"></i>
                </div>
              </div>
              <div class="country-top" v-else>
                <div class="left">
                  <span class="round"></span>
                  <span class="title">{{ country.countryTypeName }}</span>
                </div>
                <div class="right" @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'asianList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'asianList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <div class="cell" v-if="country.codes.length === 0">
                <div class="name"><span>*</span>仓库</div>
                <div @click="
                  handleNewChooseStash(
                    orderIndex,
                    colorKey,
                    'asianList',
                    countryKey
                  )
                  ">
                  <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                    colorKey,
                    'asianList',
                    countryKey) > country.codes.length"></i>
                </div>
              </div>
              <template v-else>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex,
                  colorKey,
                  'asianList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </template>
            </div>

            <div class="country-box" v-if="getLength(color, 'asianList')">
              <div class="close" @click.stop="
                handleDeleteOldCountry(orderIndex, colorKey, 'asianList')
                ">
                <i class="iconfont icon-close"></i>
              </div>
              <div class="country-item" v-for="(country, countryKey) in getDecideList(
                color,
                'asianList'
              )" :key="countryKey">
                <div class="country-top">
                  <div class="left">
                    <span class="round"></span>
                    <span class="title">{{ country.countryTypeName }}</span>
                  </div>
                  <div class="right" @click="
                    handleNewChooseStash(
                      orderIndex,
                      colorKey,
                      'asianList',
                      countryKey
                    )
                    ">
                    <i class="iconfont icon-tianjia" v-if="getCountryNum(orderIndex,
                      colorKey,
                      'asianList',
                      countryKey) > country.codes.length"></i>
                  </div>
                </div>
                <div class="warehouse-item" :key="codeKey" v-for="(code, codeKey) in country.codes" @click="chooseStash(orderIndex, colorKey,
                  'asianList',
                  countryKey, codeKey)">
                  <div class="warehouse-left">
                    <div class="line">
                      <div class="row">
                        <div class="label">仓库：</div>
                        <div class="value">{{ code.code }}</div>
                      </div>
                      <div class="row">
                        <div class="label">数量：</div>
                        <div class="value">{{ code.goodSum }}</div>
                      </div>
                    </div>
                    <div class="line">
                      <div class="row">
                        <div class="label">开船时间：</div>
                        <div class="value">
                          {{ code.shipTime | dateFormat("yyyy/MM/dd") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warehouse-right">
                    <i class="iconfont icon-a-xialakaobei"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="colorPicker" round position="bottom">
      <van-picker :title="'颜色要求'" show-toolbar :columns="activeColorList" @cancel="colorPicker = false"
        @confirm="colorConfirm" value-key="dictLabel" />
    </van-popup>
    <van-popup v-model="marketPicker" round position="bottom">
      <van-picker :title="'选择国家'" show-toolbar value-key="ctName" :columns="rowMarketList"
        @cancel="marketPicker = false" @confirm="marketConfirm" />
    </van-popup>
    <van-popup v-model="materialPicker" round position="bottom">
      <van-picker :title="'材质要求'" show-toolbar :columns="activeMaterialList" @cancel="materialPicker = false"
        @confirm="materialConfirm" />
    </van-popup>
    <van-popup v-model="barrerPicker" round position="bottom">
      <van-picker :title="'市场'" show-toolbar :columns="activeBazaar" @cancel="barrerPicker = false"
        @confirm="barrzerConfirm" />
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { mapMutations } from "vuex";
import { v4 as uuid } from "uuid";
import { sampleApi } from '../api/lookApi/api'

const pageApi = new sampleApi()

export default {
  name: "ViewingSamplePhoneDecisionForm",
  props: {
    colorList: {
      default: [],
    },
    prfTLookDecide: {},
    orderList: {},
  },
  data() {
    return {
      colorPicker: false,
      marketPicker: false,
      formList: [],
      colorName: "",
      formItem: {
        orderList: [],
        packMaterial: null,
        isDecide: true,
      },
      formCt: {
        codes: [],
        countryTypeName: "",
        marketType: null,
        market: null,
        isError: false,
      },
      formCode: {
        code: "",
        codeId: "",
        goodSum: null,
        market: null,
        shipTime: "",
      },
      rowItem: {},
      rowCt: {},
      rowCode: {},
      isAdd: true,
      isError: false,
      rowCodeIndex: 0,
      marketList: [
        {
          ctType: 1,
          ctName: "美国",
          ctValue: 1,
        },
        {
          ctType: 1,
          ctName: "澳大利亚",
          ctValue: 11,
        },
        {
          ctType: 1,
          ctName: "加拿大",
          ctValue: 2,
        },
        {
          ctType: 2,
          ctName: "德国",
          ctValue: 3,
        },
        {
          ctType: 2,
          ctName: "法国",
          ctValue: 4,
        },
        {
          ctType: 2,
          ctName: "西班牙",
          ctValue: 5,
        },
        {
          ctType: 2,
          ctName: "意大利",
          ctValue: 6,
        },
        {
          ctType: 2,
          ctName: "英国",
          ctValue: 7,
        },
        {
          ctType: 3,
          ctName: "日本",
          ctValue: 8,
        },
        {
          ctType: 3,
          ctName: "韩国",
          ctValue: 9,
        },
        {
          ctType: 3,
          ctName: "新加坡",
          ctValue: 10,
        },
        {
          ctType: 3,
          ctName: "阿联酋",
          ctValue: 12,
        },
        {
          ctType: 3,
          ctName: "沙特阿拉伯",
          ctValue: 13,
        },
      ],
      rowMarketList: [],
      activeColorList: [],
      activeMaterialList: [],
      materialPicker: false,
      materialRowItem: null,
      materialList: [
        {
          text: "六面泡沫包装",
          value: 1,
        },
        {
          text: "蜂窝包装",
          value: 2,
        },
        {
          text: "蜂窝包装+FSC",
          value: 3,
        },
      ],
      colorRowItem: null,
      bazaar: [
        {
          text: "美加澳市场",
          value: 1,
        },
        {
          text: "欧洲市场",
          value: 2,
        },
        {
          text: "亚洲市场",
          value: 3,
        },
      ],
      activeBazaar: [],
      barrerPicker: false,
      barrerRow: null,
      rowCodes: {},
      countryList: []
    };
  },
  watch: {
    orderList(val) {
      this.handleInit(val);
    },
  },
  mounted() {
    this.getCountryList();
  },

  methods: {
    ...mapMutations(["setStash"]),
    getCountryNum(index1, index2, key, index3) {
      let num = 0;
      this.countryList.forEach((item) => {
        if (item.countryTypeName === this.formList[index1].orderList[index2][key][index3].countryTypeName) {
          num = item.codeList.length;
        }
      });
      return num;
    },
    async getCountryList() {
      const list = await pageApi.getStashList();
      this.countryList = list;
    },
    handleInit(val) {
      if (val) {
        this.formList = JSON.parse(JSON.stringify(val));
      }
    },
    addCt(order, key, type) {
      let obj = JSON.parse(JSON.stringify(this.formCt));
      obj.marketType = type;
      order[key].push(obj);
    },
    getSum(row) {
      let num = 0;
      row.forEach((ct) => {
        ct.codes.forEach((code) => {
          if (code.goodSum) {
            num += code.goodSum * 1;
          }
        });
      });
      return num;
    },
    getMarketSum(market) {
      let sum = 0;
      market.allList.forEach((ct) => {
        ct.codes.forEach((code) => {
          if (code.goodSum) sum += code.goodSum * 1;
        });
      });
      market.asianList.forEach((ct) => {
        ct.codes.forEach((code) => {
          if (code.goodSum) sum += code.goodSum * 1;
        });
      });
      market.europeList.forEach((ct) => {
        ct.codes.forEach((code) => {
          if (code.goodSum) sum += code.goodSum * 1;
        });
      });
      return sum;
    },
    handleNewChooseStash(index1, index2, key, index3) {
      this.rowCodes = {
        index1,
        index2,
        key,
        index3,
      };
      let codes = [];
      this.formList[index1].orderList[index2][key][index3].codes.forEach(
        (item) => {
          codes.push(item.codeId);
        }
      );
      this.$router.push({
        path: "choose-stash",
        query: {
          proofId: this.$route.query.proofId,
          userId: this.$route.query.userId,
          type: "decide",
          codes: JSON.stringify(codes),
          countryTypeName: this.formList[index1].orderList[index2][key][index3].countryTypeName
        },
      });
      this.isAdd = true;
    },
    /* 添加/删除/修改仓库 */
    chooseStash(index1, index2, key, index3, index4) {
      this.rowCodes = {
        index1,
        index2,
        key,
        index3,
        index4
      };
      let codes = [];
      this.formList[index1].orderList[index2][key][index3].codes.forEach(
        (item) => {
          codes.push(item.codeId);
        }
      );
      this.$router.push({
        path: "choose-stash",
        query: {
          proofId: this.$route.query.proofId,
          userId: this.$route.query.userId,
          code: JSON.stringify(this.formList[index1].orderList[index2][key][index3].codes[index4]),
          length: this.formList[index1].orderList[index2][key][index3].codes.length,
          type: "decide",
          codes: JSON.stringify(codes),
          countryTypeName: this.formList[index1].orderList[index2][key][index3].countryTypeName
        },
      });
      this.isAdd = false;
      // if (this.prfTLookDecide) {
      //   return;
      // }
      // let codes = [];
      // ct.forEach((item) => {
      //   if (!code || item.codeId != code.codeId) codes.push(item.codeId);
      // });
      // if (!code) {
      //   this.rowCodes = ct;
      //   this.$router.push({
      //     path: "choose-stash",
      //     query: {
      //       proofId: this.$route.query.proofId,
      //       userId: this.$route.query.userId,
      //       type: "decide",
      //       codes: JSON.stringify(codes),
      //     },
      //   });
      //   this.isAdd = true;
      // } else {
      // this.rowCodes = ct;
      // this.rowCode = code;
      // this.$router.push({
      //   path: "choose-stash",
      //   query: {
      //     proofId: this.$route.query.proofId,
      //     userId: this.$route.query.userId,
      //     code: JSON.stringify(code),
      //     length: ct.length,
      //     type: "decide",
      //     codes: JSON.stringify(codes),
      //   },
      // });
      // this.isAdd = false;
      // // }
      // this.rowCodeIndex = index;
    },
    handleStash(query) {
      const { codeId, countryId, goodSum, shipTime, stashName } = query;
      if (this.isAdd) {
        let { index1, index2, key, index3 } = this.rowCodes;
        this.formList[index1].orderList[index2][key][index3].codes.push({
          code: stashName,
          countryId,
          codeId,
          goodSum,
          shipTime,
        });
      } else {
        // this.rowCode.code = stashName;
        // this.rowCode.codeId = codeId;
        // this.rowCode.goodSum = goodSum;
        // this.rowCode.shipTime = shipTime;
        let { index1, index2, key, index3, index4 } = this.rowCodes;
        this.formList[index1].orderList[index2][key][index3].codes[index4].code = stashName;
        this.formList[index1].orderList[index2][key][index3].codes[index4].countryId = countryId;
        this.formList[index1].orderList[index2][key][index3].codes[index4].codeId = codeId;
        this.formList[index1].orderList[index2][key][index3].codes[index4].goodSum = goodSum;
        this.formList[index1].orderList[index2][key][index3].codes[index4].shipTime = shipTime;
      }
      this.$nextTick(() => {
        this.setStash({});
      });
    },
    colorConfirm(val) {
      this.formList[this.colorRowItem].orderList.unshift({
        isDecide: true,
        allList: [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
            uuid: uuid().split("-").join(""),
          },
        ],
        colorAsk: val.dictValue,
        colorAskName: val.dictLabel,
        asianList: [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
            uuid: uuid().split("-").join(""),
          },
        ],
        europeList: [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
            uuid: uuid().split("-").join(""),
          },
        ],
      });
      this.colorPicker = false;
    },
    checkColor(index) {
      let list = [];
      let colorList = [];
      this.formList[index].orderList.forEach((order) => {
        if (order.colorAsk) {
          list.push(order.colorAsk);
        }
      });
      colorList = this.colorList.filter((color) => {
        return list.indexOf(color.dictValue) == -1;
      });
      this.activeColorList = JSON.parse(JSON.stringify(colorList));
      this.colorPicker = true;
      this.colorRowItem = index;
    },
    checkCt(ctList, ct) {
      this.rowCt = ct;
      this.marketPicker = true;
      let list = [];
      ctList.forEach((_ct) => {
        if (_ct.market != ct.market) list.push(_ct.market);
      });

      this.rowMarketList = this.marketList.filter((item) => {
        return ct.marketType == item.ctType && list.indexOf(item.ctValue) == -1;
      });
    },
    delCt(list, index, orderIndex, type) {
      Dialog.confirm({
        title: "提示",
        title: "是否确认删除？",
        confirmButtonColor: "#3F996C",
      }).then(() => {
        list.splice(index, 1);
        if (
          type == 2 &&
          this.formList[orderIndex].allList.length == 0 &&
          this.formList[orderIndex].europeList.length == 0 &&
          this.formList[orderIndex].asianList.length == 0
        ) {
          this.formList.splice(orderIndex, 1);
        }
      });
    },
    stashDel() {
      if (this.rowCodeIndex || this.rowCodeIndex == 0) {
        this.rowCodes.splice(this.rowCodeIndex, 1);
      }
      this.formList.forEach((order, orderIndex) => {
        order.allList = order.allList.filter((item) => {
          return item.codes.length > 0;
        });
        order.asianList = order.asianList.filter((item) => {
          return item.codes.length > 0;
        });
        order.europeList = order.europeList.filter((item) => {
          return item.codes.length > 0;
        });

        if (
          !order.isDecide &&
          order.allList.length == 0 &&
          order.asianList.length == 0 &&
          order.europeList.length == 0
        ) {
          this.formList.splice(orderIndex, 1);
        }
      });
      this.$nextTick(() => {
        this.setStash({});
      });
    },
    delOrder(orderIndex) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认删除该材质?",
        confirmButtonColor: "#3F996C",
      })
        .then(() => {
          this.formList.splice(orderIndex, 1);
        })
        .catch(() => { });
    },
    marketConfirm(val) {
      let { key, index1, index2, uuid } = this.rowCt;
      let index = null;
      this.formList[index1].orderList[index2][key].forEach((item, _index) => {
        if (item.uuid === uuid) {
          index = _index;
        }
      });
      this.formList[index1].orderList[index2][key][index].market = val.ctValue;
      this.formList[index1].orderList[index2][key][index].countryTypeName = val.ctName;
      this.marketPicker = false;
    },
    addColor() {
      this.formList.unshift(JSON.parse(JSON.stringify(this.formItem)));
    },
    checkValid() {
      this.isError = false;
      this.formList.forEach((order) => {
        if (!order.packMaterial) {
          this.isError = true;
          Toast("请选择材质！");
        }
        if (order.orderList.length === 0) {
          Toast("请至少添加一个颜色！");
          this.isError = true;
        }

        order.orderList.forEach((color) => {
          if (color.allList.length > 0) {
            color.allList.forEach((all) => {
              if (all.codes.length === 0) {
                this.isError = true;
                Toast("请至少添加一个仓库！");
              }
            });
          }
          if (color.asianList.length > 0) {
            color.asianList.forEach((all) => {
              if (all.codes.length === 0) {
                this.isError = true;
                Toast("请至少添加一个仓库！");
              }
            });
          }
          if (color.europeList.length > 0) {
            color.europeList.forEach((all) => {
              if (all.codes.length === 0) {
                this.isError = true;
                Toast("请至少添加一个仓库！");
              }
            });
          }
        });
      });

      if (this.formList.length == 0) {
        Toast("请至少添加一个材质！");
      }
      if (this.isError) {
        this.$nextTick(() => {
          let el = document.getElementsByClassName("is-error");
          window.scrollTo(el[0].offsetTop, 0);
        });
      }
      return this.isError;
    },
    materialConfirm(val) {
      this.materialPicker = false;
      this.formList[this.materialRowItem].packMaterial = val.value;
    },
    checkMaterial(index) {
      this.materialPicker = true;
      let packMaterial = this.formList[index].packMaterial;
      let cList = [];
      this.formList.forEach((item) => {
        if (item.packMaterial && item.packMaterial != packMaterial) {
          cList.push(item.packMaterial);
        }
      });

      this.activeMaterialList = this.materialList.filter((item) => {
        return cList.indexOf(item.value) === -1;
      });
      this.materialRowItem = index;
    },
    handleColorAdd() {
      this.colorPicker = true;
    },
    handleAddCountry(key, index1, index2, boolen) {
      if (!boolen) {
        this.formList[index1].orderList[index2][key].unshift({
          codes: [],
          countryId: "",
          countryTypeName: "",
          isDecide: true,
          market: null,
          uuid: this.GetUniqueID(),
        });
      }
    },
    getisDecideList(list, key) {
      let clist = [];

      for (let i = 0; i < list[key].length; i++) {
        if (list[key][i].isDecide) {
          clist.push(list[key][i]);
        }
      }
      return clist;
    },
    getDecideList(list, key) {
      let clist = [];

      for (let i = 0; i < list[key].length; i++) {
        if (!list[key][i].isDecide) {
          clist.push(list[key][i]);
        }
      }

      return clist;
    },
    handleAddCt(key, index1, index2, ctType, uuid) {
      this.rowCt = {
        key,
        index1,
        index2,
        uuid,
      };
      this.marketPicker = true;

      let item = null;
      this.formList[index1].orderList[index2][key].forEach((_item, _index) => {
        if (_item.uuid === uuid) {
          item = _item;
        }
      });

      let list = [];
      this.formList[index1].orderList[index2][key].forEach((_ct) => {
        if (item.market != _ct.market) list.push(_ct.market);
      });

      this.rowMarketList = this.marketList.filter((item) => {
        return ctType == item.ctType && list.indexOf(item.ctValue) == -1;
      });
    },
    getLength(list, key) {
      let clist = [];

      for (let i = 0; i < list[key].length; i++) {
        if (!list[key][i].isDecide) {
          clist.push(list[key][i]);
        }
      }

      return clist.length !== 0;
    },
    GetUniqueID() {
      // 当前时间转成 36 进制字符串
      var time = Date.now().toString(36);
      // 当前随机数转成 36 进制字符串
      var random = Math.random().toString(36);
      // 去除随机数的 0. 字符串
      random = random.substring(2, random.length);
      // 返回唯一ID
      return random + time;
    },
    barrzerConfirm(val) {
      let { index1, index2 } = this.barrerRow;
      this.barrerPicker = false;
      if (val.value === 1) {
        this.formList[index1].orderList[index2].allList = [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
          },
        ];
      } else if (val.value === 2) {
        this.formList[index1].orderList[index2].europeList = [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
          },
        ];
      } else if (val.value === 3) {
        this.formList[index1].orderList[index2].asianList = [
          {
            isDecide: true,
            codes: [],
            countryId: "",
            countryTypeName: "",
          },
        ];
      }
    },
    handleAddBarrzer(index1, index2) {
      this.barrerRow = {
        index1,
        index2,
      };
      let list = [];
      let { allList, asianList, europeList } =
        this.formList[index1].orderList[index2];

      if (
        allList.length === 0 ||
        asianList.length === 0 ||
        europeList.length === 0
      ) {
        this.barrerPicker = true;
        if (allList.length === 0) {
          list.push({
            text: "美加澳市场",
            value: 1,
          });
        }
        if (asianList.length === 0) {
          list.push({
            text: "亚洲市场",
            value: 3,
          });
        }
        if (europeList.length === 0) {
          list.push({
            text: "欧洲市场",
            value: 2,
          });
        }

        this.activeBazaar = list;
      }
    },
    handleAddWarehouse(index1, index2, key) {
    },
    handleDeleteCountry(index1, index2, key, uuid) {
      let index = null;
      this.formList[index1].orderList[index2][key].forEach((item, _key) => {
        if (item.uuid === uuid) {
          index = _key;
        }
      });
      if (index >= 0) {
        this.formList[index1].orderList[index2][key].splice(index, 1);
      }
    },
    handleDeleteOldCountry(index1, index2, key) {
      this.formList[index1].orderList[index2][key].forEach((item, _key) => {
        if (!item.uuid) {
          this.formList[index1].orderList[index2][key].splice(_key, 1);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  margin-top: 30px;

  .material-box {
    .close {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(0%, -50%);
    }

    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    border-radius: 22px;
    position: relative;
    margin-top: 30px;
    padding-bottom: 30px;

    .cell {
      &.no-boder {
        border: none;
      }

      .material {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 32px;
        color: #303133;
      }

      .button {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 28px;
        color: #3f996c;

        &.disabled {
          color: #c0c4cc;
        }
      }

      .title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 32px;
        color: #303133;
      }
    }

    .color-item {
      padding-bottom: 30px;
      border-bottom: 1px solid #dbdbdb;

      &:last-child {
        border-bottom: none;
      }
    }

    .country-box {
      width: 100%;
      // height: 645px;
      background: #f7f7f7;
      border-radius: 22px;
      padding: 30px;
      box-sizing: border-box;
      position: relative;

      .close {
        // transform: translate(-50%);
      }

      .icon-tianjia {
        font-size: 34px;
        color: #3f996c;
      }
    }

    .country-item {
      .country-top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;

          .title {
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 32px;
            color: #303133;
          }

          .round {
            width: 12px;
            height: 12px;
            background: #3f996c;
            border-radius: 50%;
            margin-right: 9px;
          }
        }

        .right {}
      }
    }
  }

  .country-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;

      .title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 32px;
        color: #303133;
      }

      .round {
        width: 12px;
        height: 12px;
        background: #3f996c;
        border-radius: 50%;
        margin-right: 9px;
      }
    }

    .right {}
  }

  .warehouse-item {
    margin-top: 13px;
    display: flex;
    justify-content: space-between;
    gap: 130px;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    padding-bottom: 30px;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .warehouse-left {
      flex: 1;

      .line {
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        &:first-child {
          margin-bottom: 19px;
        }

        .row {
          display: flex;
          align-items: center;

          .label,
          .value {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 28px;
            color: #303133;
          }
        }
      }
    }

    .warehouse-right {
      display: flex;
      align-items: center;

      .icon-a-xialakaobei {
        display: flex;
        font-size: 17px;
        color: #b3b3b3;
        transform: rotate(90deg);
      }
    }
  }

  .is-error {
    color: #f56c6c;
  }

  // .color-box {
  //   width: 100%;
  //   background: #fff;
  //   box-sizing: border-box;
  //   padding: 0 20px;
  //   border-radius: 22px;
  //   position: relative;
  //   margin-top: 30px;
  //   padding-bottom: 30px;
  //   // overflow: hidden;

  //   .close {
  //     position: absolute;
  //     right: -15px;
  //     top: -15px;
  //     width: 36px;
  //     height: 36px;
  //     font-size: 32px;
  //     display: flex;
  //     background: #f56c6c;
  //     box-sizing: border-box;
  //     align-items: center;
  //     justify-content: center;
  //     border-radius: 50%;
  //     line-height: normal;

  //     // color: #fff;
  //     .icon-close {
  //       color: #fff;
  //       flex-shrink: 0;

  //     }
  //   }

  //   &.active {
  //     padding: 0;
  //   }

  //   &.textarea-box {
  //     padding: 20px 20px;
  //     text-align: left;
  //     font-size: 32px;

  //     .box-height {
  //       min-height: 200px;
  //     }

  //     &.error {
  //       border: 1px solid #f56c6c;
  //     }
  //   }

  //   .cell {

  //     .choose {

  //       .icon-tianjia {
  //         font-size: 34px;
  //         color: #3f996c;
  //       }

  //       .color {
  //         color: #303133;
  //       }

  //     }

  //     .is-error {
  //       color: #f56c6c;
  //     }

  //     .choose-stash {
  //       display: flex;
  //       align-items: center;
  //       padding-right: 0;
  //       column-gap: 6px;

  //       >span {
  //         color: #3f996c;
  //         font-size: 32px;
  //       }

  //       .icon-tianjia {
  //         position: inherit;
  //         font-size: 34px;
  //         color: #3f996c;
  //       }

  //       .color {
  //         color: #303133;
  //       }
  //     }
  //   }

  //   .decide-market-cell {
  //     .top-row {
  //       display: flex;
  //       justify-content: space-between;
  //       margin: 10px 0 40px 0;
  //       font-size: 32px;
  //       line-height: normal;

  //       .title {
  //         font-weight: bold;
  //         color: #303133;
  //       }

  //       .right {
  //         display: flex;
  //         align-items: center;
  //         color: #3f996c;

  //         column-gap: 6px;

  //         .icon-tianjia {
  //           color: #3f996c;
  //           font-size: 34px;
  //         }
  //       }
  //     }

  //     .market-item {
  //       &:not(:last-child) {

  //         margin-bottom: 40px;
  //       }

  //     }

  //     .ct-box {
  //       background: #f7f7f7;
  //       border-radius: 22px;
  //       padding: 0 30px;
  //       position: relative;

  //       &:not(:last-child) {
  //         margin-bottom: 48px;
  //       }

  //       .ct-cell {
  //         display: flex;
  //         justify-content: space-between;
  //         align-items: center;
  //         font-size: 32px;
  //         height: 92px;

  //         .choose {
  //           display: flex;
  //           align-items: center;
  //           color: #909399;

  //           .icon-a-xialakaobei {
  //             color: #909399;
  //             margin-left: 5px;
  //             transform: rotate(90deg);
  //             transform-origin: center;
  //             display: inline-block;
  //             font-size: 16px;
  //             scale: 0.7;
  //           }
  //         }

  //         .color {
  //           color: #303133;
  //         }

  //         .is-error {
  //           color: #f56c6c;
  //         }

  //       }
  //     }

  //     .empty-box {
  //       background: #f7f7f7;
  //       height: 196px;
  //       border-radius: 22px;
  //     }
  //   }

  //   .advice-market-cell {
  //     font-size: 32px;

  //     .title {
  //       font-weight: bold;
  //       text-align: left;
  //     }

  //     .ct-box {
  //       background: #f7f7f7;
  //       margin-top: 28px;
  //       border-radius: 22px;
  //       padding: 0 30px;
  //       position: relative;

  //       .ct-cell {
  //         display: flex;
  //         align-items: center;
  //         line-height: normal;
  //         column-gap: 8px;
  //         padding: 30px 0 20px 0;
  //         font-weight: bold;

  //         .doll {
  //           display: inline-block;
  //           width: 12px;
  //           height: 12px;
  //           background: #3f996c;
  //           border-radius: 50%;
  //         }
  //       }

  //       .cell {
  //         border-top: none;
  //       }
  //     }

  //     .look-ct {
  //       background: #fff;
  //       padding: 0;
  //       margin-top: 0;
  //     }
  //   }

  //   .no-boder {
  //     border: none;
  //   }

  //   .cell-code {
  //     display: flex;
  //     justify-content: space-between;
  //     font-size: 28px;
  //     height: 135px;
  //     box-sizing: border-box;
  //     align-items: center;
  //     border-bottom: 1px solid #dbdbdb;

  //     .icon-a-xialakaobei {
  //       color: #909399;
  //       margin-left: 5px;
  //       transform: rotate(90deg);
  //       transform-origin: center;
  //       display: inline-block;
  //       font-size: 16px;
  //       scale: 0.7;
  //     }

  //     .left {
  //       color: #303133;

  //       .top {
  //         display: flex;
  //         margin-bottom: 20px;
  //         column-gap: 120px;
  //       }

  //       .top,
  //       .bottom {
  //         text-align: left;
  //       }
  //     }
  //   }

  //   .fst-cell {
  //     margin-top: -30px;
  //   }

  //   .no-border {
  //     border: none;
  //   }
  // }
}

.no-border {
  border: none;
}

.close {
  width: 36px;
  height: 36px;
  font-size: 32px;
  display: flex;
  background: #f56c6c;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: normal;

  .icon-close {
    color: #fff;
    flex-shrink: 0;
  }
}
</style>
